<app-spinner [isActive]="submitIsActive"></app-spinner>
<div class="modal-body">
    <div class="card">
        <div class="modal-header modal-close">
            <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="card-header modal-card-header">
            <h4 class="card-title" id="basic-layout-form">
                {{ (isEditMode ? 'documentIntelligenceModel.editTitle' : 'documentIntelligenceModel.createTitle') |
                translate }}
            </h4>
            <p class="mb-0">{{'documentIntelligenceModel.text' | translate}}</p>
        </div>
        <div class="card-body">
            <div [class]="hasDesktopView ? 'px-3' : 'px-2'">
                <form class="form" #documentIntelligenceModelForm="ngForm"
                    (ngSubmit)="onSubmit(documentIntelligenceModelForm)">
                    <div class="form-body">
                        <h4 class="form-section">
                            <i class="ft-cpu"></i> {{'documentIntelligenceModel.detailsHeader' | translate}}
                        </h4>

                        <!-- ModelID -->
                        <div class="form-group">
                            <label for="ModelId">{{'documentIntelligenceModel.modelIdFieldLabel' | translate}}</label>
                            <input [disabled]="isViewMode" type="text" class="form-control" name="ModelId"
                                #ModelId="ngModel" [(ngModel)]="currentObject.ModelId"
                                placeholder="{{'documentIntelligenceModel.modelIdFieldPlaceHolder' | translate}}"
                                [maxlength]="MAX_LENGTH" required />
                            <small class="form-text text-muted"
                                *ngIf="ModelId.invalid && (ModelId.dirty || ModelId.touched)">
                                {{'documentIntelligenceModel.modelIdInformationText' | translate:{max: MAX_LENGTH} }}
                            </small>
                        </div>

                        <!-- Provider -->
                        <div class="form-group">
                            <label for="Provider">{{'documentIntelligenceModel.providerFieldLabel' | translate}}</label>
                            <select [disabled]="isViewMode" class="form-control" name="Provider" #Provider="ngModel"
                                (change)=onProviderChange($event)
                                [(ngModel)]="currentObject.Provider" required>
                                <option *ngFor="let provider of providers" [value]="provider">
                                    {{ provider }}
                                </option>
                            </select>
                            <small class="form-text text-muted"
                                *ngIf="Provider.invalid && (Provider.dirty || Provider.touched)">
                                {{'documentIntelligenceModel.providerInformationText' | translate}}
                            </small>
                        </div>

                        <!-- ProviderModelId -->
                        <div class="form-group">
                            <label for="ProviderModelId">{{'documentIntelligenceModel.providerModelIdFieldLabel' | translate}}</label>
                            <input [disabled]="isViewMode" mode="text" class="form-control" name="ProviderModelId"
                                #ProviderModelId="ngModel" [(ngModel)]="currentObject.ProviderModelId"
                                placeholder="{{'documentIntelligenceModel.providerModelIdFieldPlaceHolder' | translate}}"
                                [maxlength]="MAX_LENGTH" required />
                            <small class="form-text text-muted"
                                *ngIf="ProviderModelId.invalid && (ProviderModelId.dirty || ProviderModelId.touched)">
                                {{'documentIntelligenceModel.providerModelIdInformationText' | translate:{max: MAX_LENGTH} }}
                            </small>
                        </div>

                        <!-- DocumentType -->
                        <div class="form-group">
                            <label for="DocumentType">{{'documentIntelligenceModel.documentTypeFieldLabel' | translate}}</label>
                            <input [disabled]="isViewMode" mode="text" class="form-control" name="DocumentType"
                                #DocumentType="ngModel" [(ngModel)]="currentObject.DocumentType"
                                placeholder="{{'documentIntelligenceModel.documentTypeFieldPlaceHolder' | translate}}"
                                [maxlength]="MAX_LENGTH" />
                            <small class="form-text text-muted"
                                *ngIf="DocumentType.invalid && (DocumentType.dirty || DocumentType.touched)">
                                {{'documentIntelligenceModel.documentTypeInformationText' | translate:{max: MAX_LENGTH} }}
                            </small>
                        </div>

                        <!-- DefaultFormatConverter -->
                        <div class="form-group">
                            <label for="DefaultFormatConverter">
                                {{'documentIntelligenceModel.defaultFormatConverterFieldLabel' | translate}}
                            </label>
                            <select [disabled]="isViewMode" class="form-control" name="DefaultFormatConverter"
                                #DefaultFormatConverter="ngModel" [(ngModel)]="defaultFormatConverter"
                                [disabled]="formatConverters.length == 0">
                                <option value="none">{{'documentIntelligenceModel.noFormatConverterFieldLabel' | translate}}</option>
                                <option *ngFor="let formatConverter of formatConverters" [value]="formatConverter">
                                    {{'documentIntelligenceModel.formatConverter_' + formatConverter | translate}}
                                </option>
                            </select>
                        </div>

                        <!-- MappingSpecification -->
                        <div class="form-group" *ngIf="supportsMappingSpecification">
                            <label for="MappingSpecification">
                                {{'documentIntelligenceModel.mappingSpecificationFieldLabel' | translate}}
                            </label>
                            <textarea [disabled]="isViewMode" class="form-control mapping-specification"
                                name="MappingSpecification" #MappingSpecification="ngModel"
                                [(ngModel)]="currentObject.MappingSpecification"
                                placeholder="{{'documentIntelligenceModel.mappingSpecificationFieldPlaceHolder' | translate}}"
                                rows="12" (blur)="onMappingSpecificationChanged()"></textarea>
                            <small class="form-text text-danger" *ngIf="hasMappingSpecificationError">
                                {{'documentIntelligenceModel.mappingSpecificationInvalidText' | translate}}
                            </small>
                            <small class="form-text text-muted" *ngIf="!hasMappingSpecificationError">
                                {{'documentIntelligenceModel.mappingSpecificationInformationText' | translate}}
                            </small>
                        </div>

                        <!-- Actions -->
                        <div class="form-actions">
                            <button [hidden]="isReadOnly || isEditMode || isViewMode"
                                class="btn btn-raised btn-warning mr-1" type="button"
                                (click)="resetForm(documentIntelligenceModelForm)">
                                <i class="ft-x"></i> {{'buttons.resetText' | translate}}
                            </button>
                            <button [hidden]="isReadOnly || isViewMode"
                                [disabled]="!documentIntelligenceModelForm.valid || hasMappingSpecificationError"
                                class="btn btn-raised btn-primary mr-1" type="submit">
                                <i class="ft-check-square"></i> {{'buttons.saveText' | translate }}
                            </button>
                            <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
                                <i class="ft-x-square"></i> {{'buttons.closeText' | translate}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
